<div class="textAreaCopyContainer-container" style="margin-bottom: 50px">
  <div class="textAreaCopyContainer">
    @if ((loading$ | async)?.errors) {
      @for (err of (loading$ | async)?.errors ;track err) {
        <p style="color: #c71717">{{err}}</p>
      }
    }
    @if ((loading$ | async)?.showProgressbar) {

      <p>{{(loading$ | async)?.actualValue}}/{{(loading$ | async)?.maxValue}}</p>
      <mat-progress-bar style="margin-bottom: 20px" mode="determinate" [value]="(loading$ | async)?.progressInPercent"></mat-progress-bar>
    }
    <div class="button-container">
      <button [disabled]="((loading$ | async)?.showProgressbar)" class="my-button" (click)="doKiMagic($event)">Daten übernehmen</button>
    </div>
  </div>
</div>

